<app-pdf-acknowledgement-panel class="panel" (contentLoad)="onContentLoad()">
</app-pdf-acknowledgement-panel>
